import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import CrucibleScene from './crucibleScene';

export default class CameraAnimator {
  public camera: THREE.Camera;
  public selectedCameraPos: THREE.Vector3;
  public isMovingCamera: boolean;
  protected _scene: CrucibleScene;
  protected _controls: OrbitControls;
  protected _alpha: number;
  protected _cameraPositions: {
    [key: string]: {
      cameraPos: THREE.Vector3;
      controlsTarget: THREE.Vector3;
      lidOpen: boolean;
    };
  };

  constructor(
    camera: THREE.Camera,
    scene: CrucibleScene,
    controls: OrbitControls
  ) {
    this._cameraPositions = {
      initial: {
        cameraPos: new THREE.Vector3(-14, 20, 28),
        controlsTarget: new THREE.Vector3(0, 0, 0),
        lidOpen: true
      },
      centralPiece: {
        cameraPos: new THREE.Vector3(-8.15, 8, 0.85),
        controlsTarget: new THREE.Vector3(0, 5, 0),
        lidOpen: true
      },
      topShell: {
        cameraPos: new THREE.Vector3(0, 40, 0),
        controlsTarget: new THREE.Vector3(0, 5, 0),
        lidOpen: false
      },
      bottomShell: {
        cameraPos: new THREE.Vector3(0.1, -31.5, 2),
        controlsTarget: new THREE.Vector3(0, 0, 0),
        lidOpen: false
      },
      idText: {
        cameraPos: new THREE.Vector3(-11, 15.86, 3.2),
        controlsTarget: new THREE.Vector3(0, 5, 0),
        lidOpen: false
      },
      rewardPrograms: {
        cameraPos: new THREE.Vector3(14.6, 9.83, 5.5),
        controlsTarget: new THREE.Vector3(3, -2.8, -5.7),
        lidOpen: true
      }
    };

    this.camera = camera;
    this._scene = scene;
    this._controls = controls;
    this.selectedCameraPos = this._cameraPositions['initial'].cameraPos;
    this._alpha = 0;
    this.isMovingCamera = false;
  }

  resetCamera() {
    this.selectedCameraPos = this._cameraPositions['initial'].cameraPos;
    this._controls.target = this._cameraPositions['initial'].controlsTarget;
    this.camera.position.set(
      this.selectedCameraPos.x,
      this.selectedCameraPos.y,
      this.selectedCameraPos.z
    );
  }

  changeSelectedCamera(cameraName: string) {
    this.selectedCameraPos = this._cameraPositions[cameraName].cameraPos;
    this._controls.target = this._cameraPositions[cameraName].controlsTarget;
    this.isMovingCamera = true;
    this._alpha = 0;
    if (this._cameraPositions[cameraName].lidOpen) {
      if (!this._scene.isLidOpen) this._scene.openLidAnimation();
    } else {
      if (this._scene.isLidOpen) this._scene.openLidAnimation();
    }
  }

  lerpPosition(
    finalPosition: THREE.Vector3,
    duration: number,
    timeElapsed: number,
    alpha: number = 0
  ) {
    if (alpha < duration) {
      this.camera.position.lerp(finalPosition, alpha / duration);
      alpha += timeElapsed;
    } else {
      this.isMovingCamera = false;
    }
  }

  animate(timeElapsed: number) {
    // console.log('camera position', this.camera.position);
    if (this.isMovingCamera) {
      this.lerpPosition(this.selectedCameraPos, 0.5, timeElapsed, this._alpha);
      this._alpha += timeElapsed;
    }
  }
}
